import { TSurveyModel } from "@performyard/models";

import { getDateCell, getSurveyNameCell } from "./components/CellRenderers";

import { getStatusChip } from "../../utils";

type SurveysConfig = {
	navLinks: {
		key: string;
		label: string;
		href: string;
	}[];
	allSurveysStaticTableCols: {
		id: string;
		label: string;
		width: number;
		getter: (row: TSurveyModel) => React.ReactNode | null;
	}[];
};

// surveys UI constants
export const SURVEYS_TABLE_LIMIT = 25;

// surveys UI config
export const surveysConfig: SurveysConfig = {
	navLinks: [
		{
			key: "all-surveys",
			label: "All Surveys",
			href: "/surveys",
		},
	],
	allSurveysStaticTableCols: [
		{
			id: "name",
			label: "Survey Name",
			width: 400,
			getter: (row: TSurveyModel) => {
				return getSurveyNameCell(row);
			},
		},
		{
			id: "status",
			label: "Status",
			width: 130,
			getter: (row: TSurveyModel) => {
				return getStatusChip(row.status);
			},
		},
		{
			id: "start_date",
			label: "Start Date",
			width: 231,
			getter: (row: TSurveyModel) => {
				return getDateCell(row.startDate ?? null);
			},
		},
		{
			id: "end_date",
			label: "End Date",
			width: 231,
			getter: (row: TSurveyModel) => {
				return getDateCell(row.endDate ?? null);
			},
		},
	],
};
